import { Box } from '@helvetia/components/Box'
import { Button } from '@helvetia/components/Button'
import LinkText from '@helvetia/components/LinkText'
import Text from '@helvetia/components/Text'
import React, { Component } from 'react'
import { withNamespaces, WithNamespaces } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { hasNoRoles } from '../core/services/auth.service'
import OfferService from '../core/services/offer.service'
import {
  clearOfferDocumentId,
  existsOfferDocument,
  getOfferDocumentId,
} from '../core/services/storage.service'
import ContactBox from './_components/HelvetiaContactBox'
import EasySVG from './_components/icons/diy.svg'
import FastSVG from './_components/icons/fast.svg'
import SafeSVG from './_components/icons/safety.svg'
import landingImage from './_components/images/landingPageImage.png'
import landingImageMedium from './_components/images/landingPageImage_md.png'
import map from './_components/images/map_europe-xs.png'

class Landing extends Component<WithNamespaces & RouteComponentProps> {
  protected hasBeenSaved: boolean = false

  async componentDidMount() {
    if (existsOfferDocument()) {
      const document = await OfferService.getOfferDocument(getOfferDocumentId())
      this.hasBeenSaved = document.offerData.progressMask[6] === '1'
    }
  }

  handleClick = () => {
    this.props.i18n.changeLanguage('en')
  }

  redirect = () => {
    if (existsOfferDocument() && this.hasBeenSaved) {
      this.props.history.push('/summary')
    } else {
      clearOfferDocumentId()
      this.props.history.push('/calculator/vehicles')
    }
  }

  render() {
    const { t } = this.props

    return (
      <>
        <Text
          as="div"
          color="black"
          size="xlBold"
          marginBottom="m"
          marginTop="m"
        >
          Carriers Liability Online
        </Text>

        <div className="visible-md visible-lg">
          <div className="uxc-h-fluid-wrapper">
            <div className="uxc-a-image-box uxc-a-image-box--center">
              <img className="uxc-a-image-box__img" src={landingImage} alt="" />

              <div className="uxc-a-image-box__content uxc-a-image-box__content--inner-size-full">
                <div className="uxc-h-spacer uxc-h-spacer--m" />
                <div className="row">
                  <div className="col-md-5 col-md-offset-1">
                    <div className="uxc-a-h-box__parent--outdent-left">
                      <div className="uxc-a-h-box uxc-a-h-box--arrow-right-top uxc-a-h-box--white uxc-a-h-box--size-auto uxc-a-h-box--placement-inside">
                        <div className="uxc-h-height-wrapper uxc-h-height-wrapper--m uxc-h-height-wrapper--align-none">
                          <div className="uxc-h-height-wrapper__content">
                            <div className="uxc-h-typography--normal-m uxc-h-typography-spacer--m">
                              I'd like to
                            </div>
                            <ul className="uxc-m-list">
                              <li className="uxc-m-list__item uxc-state-m-list__item--m">
                                <LinkText
                                  text="Calculate the policy price"
                                  color="primary"
                                  link={'/calculator/vehicles'}
                                />
                              </li>
                              <li className="uxc-m-list__item uxc-state-m-list__item--m">
                                <LinkText
                                  text="Get in touch"
                                  color="primary"
                                  link={'/contact-me'}
                                />
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="uxc-h-spacer uxc-h-spacer--m" />
              </div>
            </div>
          </div>
        </div>

        <div className="visible-xs visible-sm">
          <div className="visible-xs">
            <figure className="uxc-a-image">
              <div className="uxc-a-image__picture uxc-a-image__picture--ratio uxc-a-image__picture--4x3 uxc-a-image__picture--center">
                <img
                  className="uxc-a-image-box__img"
                  src={landingImageMedium}
                  style={{ maxWidth: '100%' }}
                  alt=""
                />
              </div>
            </figure>
          </div>
          <div className="visible-sm">
            <figure className="uxc-a-image">
              <div className="uxc-a-image__picture uxc-a-image__picture--ratio uxc-a-image__picture--16x9 uxc-a-image__picture--center">
                <img
                  className="uxc-a-image-box__img"
                  src={landingImageMedium}
                  style={{ maxWidth: '100%' }}
                  alt=""
                />
              </div>
            </figure>
          </div>
          <div className="uxc-a-h-box uxc-a-h-box--arrow-top-left uxc-a-h-box--no-margin-top uxc-a-h-box--grey1 uxc-a-h-box--size-full uxc-a-h-box--placement-inside">
            <div className="uxc-h-typography--normal-m uxc-h-typography-color--black">
              I would like to
            </div>
            <div className="uxc-m-link-carousel" data-t-name="UXCLinkCarousel">
              <a
                href="javascript:;"
                className="uxc-m-link-carousel__button-prev uxc-js-m-link-carousel__button-prev"
              />
              <a
                href="javascript:;"
                className="uxc-m-link-carousel__button-next uxc-js-m-link-carousel__button-next"
              />
              <div className="uxc-m-link-carousel__container uxc-js-m-link-carousel__container">
                <div className="uxc-m-link-carousel__wrapper uxc-js-m-link-carousel__wrapper swiper-wrapper">
                  <div className="uxc-m-link-carousel-item uxc-js-m-link-carousel-item">
                    <div className="uxc-h-spacer uxc-h-spacer--m" />
                    <LinkText
                      text="Calculate the policy price"
                      color="primary"
                      link={'/calculator/vehicles'}
                    />
                    <div className="uxc-h-spacer uxc-h-spacer--m" />
                  </div>
                  <div className="uxc-m-link-carousel-item uxc-js-m-link-carousel-item">
                    <div className="uxc-h-spacer uxc-h-spacer--m" />
                    <LinkText
                      text="Get in touch"
                      color="primary"
                      link={'/contact-me'}
                    />
                    <div className="uxc-h-spacer uxc-h-spacer--m" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-10 col-xs-offset-1">
            <Text
              as="p"
              color="black"
              size="s"
              marginBottom="xxxs"
              marginTop="m"
            >
              If you are a small or medium transport company which works in
              European territory and/or part of Russia, CLO is for you. CLO, the
              first transport insurance policy in Switzerland that can be
              calculated and contracted completely online
            </Text>
          </div>
        </div>
        <div className="uxc-h-spacer uxc-h-spacer--l" />
        <div className="uxc-h-fluid-wrapper">
          <div className="uxc-h-spacer uxc-h-spacer--xxs" />
          <div className="row">
            <div className="col-xs-12 col-md-10 col-md-offset-1">
              <div className="uxc-h-spacer uxc-h-spacer--s@desktop uxc-h-spacer--s@hd" />
              <div className="row">
                <div className="col-xs-12 col-md-4">
                  <div className="uxc-h-alignment uxc-h-alignment--center@mobile uxc-h-alignment--center@tablet">
                    <div>
                      <div className="uxc-h-alignment uxc-h-text-align--center@mobile uxc-h-text-align--center@tablet">
                        <div>
                          <img
                            src={EasySVG}
                            className="uxc-a-icon uxc-a-icon--color-inherit uxc-a-icon--size-xxxxl "
                            aria-hidden="true"
                          />
                          <Text
                            as="div"
                            color="black"
                            size="xsBold"
                            marginBottom="xxxs"
                            marginTop="xxxs"
                          >
                            Do it yourself
                          </Text>
                          <Text
                            as="div"
                            color="black"
                            size="xs"
                            marginBottom="xs"
                          >
                            Very simple steps to make it really easy.
                          </Text>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-md-4">
                  <div className="uxc-h-alignment uxc-h-alignment--center@mobile uxc-h-alignment--center@tablet">
                    <div>
                      <div className="uxc-h-alignment uxc-h-text-align--center@mobile uxc-h-text-align--center@tablet">
                        <div>
                          <img
                            src={FastSVG}
                            className="uxc-a-icon uxc-a-icon--color-inherit uxc-a-icon--size-xxxxl "
                            aria-hidden="true"
                          />
                          <Text
                            as="div"
                            color="black"
                            size="xsBold"
                            marginBottom="xxxs"
                            marginTop="xxxs"
                          >
                            Very fast
                          </Text>
                          <Text
                            as="div"
                            color="black"
                            size="xs"
                            marginBottom="xs"
                          >
                            Get a price in less than 3 minutes and contract
                            immediately
                          </Text>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-md-4">
                  <div className="uxc-h-alignment uxc-h-alignment--center@mobile uxc-h-alignment--center@tablet">
                    <div>
                      <div className="uxc-h-alignment uxc-h-text-align--center@mobile uxc-h-text-align--center@tablet">
                        <div>
                          <img
                            src={SafeSVG}
                            className="uxc-a-icon uxc-a-icon--color-inherit uxc-a-icon--size-xxxxl "
                            aria-hidden="true"
                          />
                          <Text
                            as="div"
                            color="black"
                            size="xsBold"
                            marginBottom="xxxs"
                            marginTop="xxxs"
                          >
                            Reliable
                          </Text>
                          <Text
                            as="div"
                            color="black"
                            size="xs"
                            marginBottom="xs"
                          >
                            If you prefer to compare with others, save your
                            offer and retrieve it later.
                          </Text>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="uxc-h-spacer uxc-h-spacer--l" />
        <Box grey size="xxs">
          <div className="uxc-h-spacer uxc-h-spacer--l" />

          <div className="uxc-h-fluid-wrapper ">
            <div className="row">
              <div className="col-xs-12 col-md-10 col-md-offset-1">
                <Text as="div" color="black" size="l">
                  Risks coverage
                </Text>
                <div className="uxc-h-spacer uxc-h-spacer--s" />
                <div
                  className="uxc-m-accordion"
                  data-t-name="UXCAccordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div className="uxc-m-accordion__item uxc-js-m-accordion__item uxc-state-m-accordion__item--expanded">
                    <h3
                      id="uxc-a-accordion-tab1"
                      className="uxc-m-accordion__item__label uxc-js-m-accordion__label"
                      aria-controls="uxc-a-accordion-panel1"
                      aria-selected="true"
                      aria-expanded="true"
                      tabIndex={0}
                      role="tab"
                    >
                      Good to know
                    </h3>
                    <div className="uxc-h-spacer uxc-h-spacer--xxxs" />
                    <div
                      id="uxc-a-accordion-panel1"
                      className="uxc-m-accordion__item__content uxc-js-m-accordion__content "
                      aria-labelledby="uxc-a-accordion-tab1"
                      aria-hidden="false"
                      role="tabpanel"
                    >
                      <div className="uxc-h-spacer uxc-h-spacer--xxs" />
                      <div className="uxc-a-rich-text uxc-a-rich-text--font-size-s">
                        <p>
                          Placeat fugit harum ipsam et et velit officiis
                          quaerat. Nihil
                          <a href="components">iusto</a>. Ut atque voluptates
                          hic deleniti. Voluptatum est quo ut doloribus
                          voluptatum nemo possimus veritatis dolor. Optio qui
                          accusantium aut. Eligendi quaerat at et libero
                          excepturi et eum. Earum reiciendis rerum error. Et
                          quis cupiditate fugiat repellendus.
                        </p>
                      </div>
                      <div className="uxc-h-spacer uxc-h-spacer--xxxs" />
                    </div>
                  </div>
                  <div className="uxc-m-accordion__item uxc-js-m-accordion__item">
                    <h3
                      id="uxc-a-accordion-tab2"
                      className="uxc-m-accordion__item__label uxc-js-m-accordion__label"
                      aria-controls="uxc-a-accordion-panel2"
                      aria-selected="false"
                      aria-expanded="false"
                      tabIndex={0}
                      role="tab"
                    >
                      See some examples
                    </h3>
                    <div className="uxc-h-spacer uxc-h-spacer--xxxs" />
                    <div
                      id="uxc-a-accordion-panel2"
                      className="uxc-m-accordion__item__content uxc-js-m-accordion__content "
                      aria-labelledby="uxc-a-accordion-tab2"
                      aria-hidden="true"
                      role="tabpanel"
                    >
                      <div className="uxc-h-spacer uxc-h-spacer--xxs" />
                      <div className="uxc-a-rich-text uxc-a-rich-text--font-size-s">
                        <p>
                          Est necessitatibus rem earum natus recusandae dolor
                          rerum quisquam rerum. Praesentium ipsa inventore
                          architecto eum pariatur dicta rerum. Modi recusandae
                          iure.
                        </p>
                      </div>
                      <div className="uxc-h-spacer uxc-h-spacer--xxxs" />
                    </div>
                  </div>
                  <div className="uxc-m-accordion__item uxc-js-m-accordion__item">
                    <h3
                      id="uxc-a-accordion-tab3"
                      className="uxc-m-accordion__item__label uxc-js-m-accordion__label"
                      aria-controls="uxc-a-accordion-panel3"
                      aria-selected="false"
                      aria-expanded="false"
                      tabIndex={0}
                      role="tab"
                    >
                      Any questions?
                    </h3>
                    <div className="uxc-h-spacer uxc-h-spacer--xxxs" />
                    <div
                      id="uxc-a-accordion-panel3"
                      className="uxc-m-accordion__item__content uxc-js-m-accordion__content "
                      aria-labelledby="uxc-a-accordion-tab3"
                      aria-hidden="true"
                      role="tabpanel"
                    >
                      <div className="uxc-h-spacer uxc-h-spacer--xxs" />
                      <div className="uxc-a-rich-text uxc-a-rich-text--font-size-s">
                        <p>
                          Cupiditate autem temporibus quis et eveniet nihil
                          dolores deserunt. Maxime eius magni incidunt qui ea
                          recusandae. Molestiae qui dicta dolores nisi impedit
                          quidem quia recusandae suscipit. Quibusdam asperiores
                          dolor quia dignissimos placeat sunt. Minus dolorem
                          delectus. Est laborum odio corrupti laudantium et ad.
                          Reprehenderit at cupiditate ipsa et voluptas. Non et
                          sint corporis quisquam ea quo. Voluptate velit
                          assumenda sit est dolorum debitis est eveniet. Veniam
                          possimus repudiandae quo. Officia ab soluta nulla.
                          Molestias doloremque voluptatum non consectetur
                          consectetur dolor in repellendus.
                        </p>
                      </div>
                      <div className="uxc-h-spacer uxc-h-spacer--xxxs" />
                    </div>
                  </div>
                </div>
                <div className="uxc-h-spacer uxc-h-spacer--m" />
                <div className="uxc-h-alignment uxc-h-alignment--center">
                  <Button primary onClick={this.redirect}>
                    {existsOfferDocument() && this.hasBeenSaved
                      ? t('buttons.viewOffer')
                      : t('buttons.calculateNow')}
                  </Button>
                </div>
                <div className="uxc-h-spacer uxc-h-spacer--l" />
              </div>
            </div>
          </div>
        </Box>
        <div className="uxc-h-spacer uxc-h-spacer--l" />

        <Text as="div" color="black" size="lBold">
          Geographic scope
        </Text>
        <div className="uxc-h-spacer uxc-h-spacer--m" />
        <Text as="p" color="black" size="s">
          If you are a small or medium transport company which works in European
          territory and/or part of Russia, CLO is for you. CLO, the first
          transport insurance policy in Switzerland that can be calculated and
          contracted completely online
        </Text>

        <div className="uxc-h-spacer uxc-h-spacer--l" />
        <div className="uxc-h-alignment uxc-h-alignment--center">
          <img src={map} alt="" style={{ maxWidth: '100%' }} />
        </div>

        <div className="uxc-h-spacer uxc-h-spacer--xxl" />

        <div className="uxc-h-fluid-wrapper">
          <div className="row">
            <div className="col-xs-12 col-sm-4 col-md-3 col-lg-3 col-md-offset-2 col-sm-offset-1 col-lg-offset-2">
              <div className="uxc-a-h-box uxc-a-h-box--arrow-right-top  uxc-a-h-box--secondary uxc-a-h-box--size-full uxc-a-h-box--placement-outside">
                <h5 className="uxc-h-typography--normal-m">
                  Download and links
                </h5>
              </div>
            </div>
            <div className="uxc-h-spacer uxc-h-spacer--s visible-xs" />
            <div className="col-xs-12 col-sm-6 col-md-6 col-sm-offset-1">
              <ul className="uxc-m-list">
                <li className="uxc-m-list__item uxc-state-m-list__item--s">
                  <div className="uxc-h-typography--normal-s uxc-m-list__item--none">
                    <a className="uxc-a-link" href="#">
                      Articles of association [PDF, 643 kB]
                    </a>
                  </div>
                </li>
                <li className="uxc-m-list__item uxc-state-m-list__item--s">
                  <div className="uxc-h-typography--normal-s uxc-m-list__item--none">
                    <a className="uxc-a-link" href="#">
                      Current price information
                    </a>
                  </div>
                </li>
                <li className="uxc-m-list__item uxc-state-m-list__item--s">
                  <div className="uxc-h-typography--normal-s uxc-m-list__item--none">
                    <a className="uxc-a-link" href="#">
                      Strategy details
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="uxc-h-spacer uxc-h-spacer--xxl" />

        <div className="uxc-h-alignment uxc-h-alignment--center">
          <Button primary onClick={this.redirect}>
            {existsOfferDocument() && this.hasBeenSaved
              ? t('buttons.viewOffer')
              : t('buttons.calculateNow')}
          </Button>
        </div>
        <div className="uxc-h-spacer uxc-h-spacer--xxl" />

        {hasNoRoles() && <ContactBox />}

        <div className="uxc-h-spacer uxc-h-spacer--xxl" />
      </>
    )
  }
}

export default withNamespaces()(withRouter(Landing))
